import { useState } from 'react';
import { Dropdown } from 'components/Dropdown/Dropdown';
import SlidersHorizontal from 'images/icons/whiteIcons/SlidersHorizontal.svg';
import './styles.scss';

// TODO create filters
const Filter = ({ data }) => {
    const [selectedValue, setSelectedValue] = useState([]);

    const handleDropdownChange = value => {
        selectedValue.includes(value)
            ? setSelectedValue(prev => prev.filter(el => el !== value))
            : setSelectedValue(prev => [...prev, value]);
    };

    const onResetFilter = () => {
        setSelectedValue([]);
    };

    return (
        <div className="filter">
            <div className="filter__title">
                <img src={SlidersHorizontal} alt="filter" />
                <p className="button-text">FILTER</p>
            </div>

            {data?.map(el => (
                <div key={el.label}>
                    <Dropdown
                        label={el.label}
                        options={el.options}
                        type="filter"
                        onDropdownChange={handleDropdownChange}
                        selectedOption={selectedValue}
                    />
                </div>
            ))}
            {selectedValue && (
                <button className="button-text filter__reset-button" onClick={onResetFilter}>
                    RESET FILTER
                </button>
            )}
        </div>
    );
};

export default Filter;
